var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textarea"},[_c('label',{attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.$t(_vm.label)))]),(_vm.hasError && _vm.error)?_c('span',{staticClass:"badge-error",attrs:{"variant":"none","id":`${_vm.name}-error`}},[_c('small',[_vm._v(_vm._s(_vm.error))])]):_vm._e(),_c('textarea',_vm._g(_vm._b({class:{
      'error': _vm.hasError,
      'green': !!_vm.value && !_vm.hasError
    },attrs:{"rows":"6","cols":"50","aria-describedby":`${_vm.name}-error`,"placeholder":_vm.$t(_vm.tooltip),"name":_vm.name,"id":_vm.name},domProps:{"value":_vm.value}},'textarea',_vm.$attrs,false),{
      ..._vm.$listeners,
      input: event => _vm.$emit('input', event.target.value)
    }))])
}
var staticRenderFns = []

export { render, staticRenderFns }